const prepareAddress = ({address, city, zip, state, country}) =>
  [address, city, zip, state, country]
    .filter((partOfAddress) => !!partOfAddress)
    .map((partOfAddress) => encodeURIComponent(partOfAddress))
    .join(',');

export default prepareAddress;
